import { render, staticRenderFns } from "./ScrollSync.vue?vue&type=template&id=67b89c83&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ScrollSync.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/ScrollSync.vue
// module id = 2430
// module chunks = 1